import { poBoxRegex } from 'utils/regexes';

import type { PickupShippingMethod, ShippingMethod } from 'domains/shipping_methods';

function isExpedited(method: ShippingMethod) {
  return method.details_html !== null && poBoxRegex.test(method.details_html);
}

/**
 * Order API returns a slimmed down version for the pickup-type-only endpoint,
 * so we map them in order for their type signatures to match the other types
 */
function formatPickupMethod(method: PickupShippingMethod): ShippingMethod {
  return {
    ...method,
    charged_at_cost: false,
    price: 0,
    type: 'pickup',
  };
}

export default {
  isExpedited,
  formatPickupMethod,
};
